import { isArray } from '@razlet/utils';

export default class Requirements {
  constructor (data) {
    this.data = isArray(data) ? data : [];
  }

  get agreements () {
    return this.data.filter(item => item.area === 'agreement');
  }

  get attachments () {
    return this.data.filter(item => item.area === 'attachment');
  }
}
